import { render, staticRenderFns } from "./competition.vue?vue&type=template&id=7e070bc8&"
import script from "./competition.vue?vue&type=script&lang=js&"
export * from "./competition.vue?vue&type=script&lang=js&"
import style1 from "./competition.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports